
import Swal from 'sweetalert2';

export const catchError = (error,navigate) => {
    
    if (error.status == 403 || error.status == 404) {
        Swal.fire({ icon: "error", title: "Session Expired", text: error.message });
        navigate("/admin/login");
    }  
    else if(error.status == 402){

        const storedUser = localStorage.getItem('@roampays-user');
        
        if (storedUser) {
            const userData = JSON.parse(storedUser);
            
            // 2. Clear out the stripe package values
            if(userData.stripe_package != 0) {
                userData.stripe_package = 0;
                localStorage.setItem('@roampays-user', JSON.stringify(userData));
                window.dispatchEvent(new Event('user-subscribed'));

            }
            
            
        }

       
    }
    else {
        Swal.fire({ icon: "error", title: "Request Denied", text: error.message });
    }
}

